// Helper for concating rules in theme.

export const applyAll = (...rules) => rules.concat()

export default applyAll
